// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plan-summary-card[data-v-825d5fce] .card-body{padding:0}.min-w-100px[data-v-825d5fce]{min-width:100px}.h-250[data-v-825d5fce]{height:250px}.rounded-pill+ul li[data-v-825d5fce]{padding-bottom:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
